module.exports = __webpack_public_path__ + "img/short-form-example-2.42240cb5.png";